import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/apiService.jsx';
import './Login.css';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await authService.changePassword(currentPassword, newPassword, confirmPassword);
      setMessage('Password changed successfully. Redirecting to dashboard...');
      setTimeout(() => navigate('/dashboard'), 1200);
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-split-box">
        <div className="login-card">
          <div className="login-card-content">
            <h2>Change Password</h2>

            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="input-field">
                <label className="input-label">Current Password</label>
                <div className="input-wrapper">
                  <input type={showCurrent ? 'text' : 'password'} className="form-input" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required placeholder="Current password" />
                  <button type="button" className="password-toggle" onClick={() => setShowCurrent(s => !s)} aria-label={showCurrent ? 'Hide password' : 'Show password'}>
                    <i className={showCurrent ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
                  </button>
                </div>
              </div>

              <div className="input-field">
                <label className="input-label">New Password</label>
                <div className="input-wrapper">
                  <input type={showNew ? 'text' : 'password'} className="form-input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required placeholder="New password" />
                  <button type="button" className="password-toggle" onClick={() => setShowNew(s => !s)} aria-label={showNew ? 'Hide password' : 'Show password'}>
                    <i className={showNew ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
                  </button>
                </div>
              </div>

              <div className="input-field">
                <label className="input-label">Confirm New Password</label>
                <div className="input-wrapper">
                  <input type={showConfirm ? 'text' : 'password'} className="form-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required placeholder="Confirm new password" />
                  <button type="button" className="password-toggle" onClick={() => setShowConfirm(s => !s)} aria-label={showConfirm ? 'Hide password' : 'Show password'}>
                    <i className={showConfirm ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
                  </button>
                </div>
              </div>

              <button className="login-button" type="submit" disabled={loading}>{loading ? 'Processing...' : 'Change Password'}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
